import * as React from "react";

function SvgEmojiIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="0.8em" height="0.8em" {...props}>
      <path d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12S6.072 1.25 12 1.25 22.75 6.072 22.75 12 17.928 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z" />
      <path d="M12 17.115a5.509 5.509 0 01-4.656-2.544.748.748 0 01.226-1.035.747.747 0 011.036.226c.747 1.162 2.016 1.855 3.395 1.855s2.648-.693 3.396-1.854a.747.747 0 011.036-.225c.35.224.45.688.226 1.036a5.516 5.516 0 01-4.658 2.545z" />
      <circle cx={14.738} cy={9.458} r={1.478} />
      <circle cx={9.262} cy={9.458} r={1.478} />
    </svg>
  );
}

export default SvgEmojiIcon;
